/**
 * Created by neo on 12.01.21.
 */
import { ExploreEntry, createExploreEntry } from './ExploreEntry';

export type DefaultExploreEntry = ExploreEntry & {
  type: 'default';
};

export function createDefaultExploreEntry(json?: Partial<DefaultExploreEntry>): DefaultExploreEntry {
  return createExploreEntry({ ...json, type: 'default' }) as DefaultExploreEntry;
}
